import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AkademskiIntegritet() {
  const [t] = useTranslation();

  const docs = [
    {
      href: "/Prilozi/1. Obrazac_standard11_Pilot_evaluacija, FPEP INTEGRITET.pdf",
      titleKey: "integritet.docs.pilot",
      icon: "fa-clipboard-check",
    },
    {
      href: "/Prilozi/2. KODEKS AKADEMSKE ETIKE- od osnivanja Fakulteta.pdf",
      titleKey: "integritet.docs.kodeks",
      icon: "fa-balance-scale",
    },
    {
      href: "/Prilozi/3. Etička Povelja.pdf",
      titleKey: "integritet.docs.povelja",
      icon: "fa-scroll",
    },
    {
      href: "/Prilozi/3.1. Odluka o implementaciji etičke povelje.pdf",
      titleKey: "integritet.docs.odlukaPovelja",
      icon: "fa-stamp",
    },
    {
      href: "/Prilozi/5. Odluka Dekana o obrazovanju Odbora za kvalitet i samovrednovanje, EP.pdf",
      titleKey: "integritet.docs.odlukaOdbor",
      icon: "fa-users-cog",
    },
    {
      href: "/Prilozi/7. Statut SP.pdf",
      titleKey: "integritet.docs.statut",
      icon: "fa-book",
    },
  ];

  const homeLabel = t("breadcrumb.home", { defaultValue: "Početna" });

  return (
    <>
      <Navbar />
      <Bredcom title={homeLabel} subtitle={t("integritet.title")} />

      <div className="integrity-page">
        <div className="container mt-4 pt-40">
          <div className="row">
            {/* MAIN */}
            <div className="col-md-8">
              <div className="content-container textjustify integrity-content">
                {/* HERO */}
                <section
                  className="integrity-hero"
                  aria-label={t("integritet.title")}
                >
                  <div className="integrity-hero__eyebrow">
                    <span className="integrity-pill">
                      <i className="fas fa-shield-alt" aria-hidden="true" />
                      {t("integritet.ui.badge")}
                    </span>
                  </div>

                  <h1 className="integrity-hero__title">
                    {t("integritet.title")}
                  </h1>

                  {/* p1 stays – just moved into hero lead */}
                  <p className="integrity-hero__lead">{t("integritet.p1")}</p>

                  <div
                    className="integrity-hero__chips"
                    aria-label={t("integritet.ui.metaAria")}
                  >
                    <span className="integrity-chip">
                      <i className="far fa-file-pdf" aria-hidden="true" />
                      PDF
                    </span>
                    <span className="integrity-chip">
                      <i className="fas fa-link" aria-hidden="true" />
                      IntegritetUA
                    </span>
                    <span className="integrity-chip">
                      <i className="fas fa-check-circle" aria-hidden="true" />
                      {t("integritet.ui.readable")}
                    </span>
                  </div>
                </section>

                {/* DOCS */}
                <section id="dokumenti" className="integrity-section">
                  <div className="integrity-section__head">
                    <h2 className="integrity-section__title">
                      {t("integritet.ui.docsTitle")}
                    </h2>
                    <p className="integrity-section__lead">
                      {t("integritet.ui.docsLead")}
                    </p>
                  </div>

                  <div
                    className="integrity-docs"
                    role="list"
                    aria-label={t("integritet.ui.docsAria")}
                  >
                    {docs.map((d) => (
                      <a
                        key={d.href}
                        href={d.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="integrity-doc"
                        role="listitem"
                      >
                        <div className="integrity-doc__icon" aria-hidden="true">
                          <i className={`fas ${d.icon}`} />
                        </div>

                        <div className="integrity-doc__body">
                          <div className="integrity-doc__title">
                            {t(d.titleKey)}
                          </div>

                          <div className="integrity-doc__meta">
                            <span className="integrity-badge">PDF</span>
                            <span className="integrity-doc__open">
                              {t("integritet.ui.openPdf")}
                              <i
                                className="fas fa-external-link-alt"
                                aria-hidden="true"
                              />
                            </span>
                          </div>
                        </div>
                      </a>
                    ))}
                  </div>

                  <div className="integrity-hint" aria-hidden="true">
                    <i className="fas fa-mouse-pointer" />
                    {t("integritet.ui.docsHint")}
                  </div>
                </section>

                {/* TEXT (p2–p7 untouched) */}
                <section id="pregled" className="integrity-section">
                  <div className="integrity-section__head">
                    <h2 className="integrity-section__title">
                      {t("integritet.ui.overviewTitle")}
                    </h2>
                    <p className="integrity-section__lead">
                      {t("integritet.ui.overviewLead")}
                    </p>
                  </div>

                  <div className="integrity-prose">
                    <p>{t("integritet.p2")}</p>
                    <p>{t("integritet.p3")}</p>
                    <p>{t("integritet.p4")}</p>
                    <p>{t("integritet.p5")}</p>
                    <p>{t("integritet.p6")}</p>
                    <p>{t("integritet.p7")}</p>
                  </div>
                </section>

                {/* INTEGRITETUA highlight (p8/p9 untouched – only wrapped) */}
                <section
                  id="integritetua"
                  className="integrity-callout"
                  aria-label="IntegritetUA"
                >
                  <div className="integrity-callout__left">
                    <div className="integrity-callout__badge">
                      <i className="fas fa-satellite-dish" aria-hidden="true" />
                    </div>

                    <div className="integrity-callout__content">
                      <h3 className="integrity-callout__title">
                        {t("integritet.ui.integritetuaTitle")}
                      </h3>

                      <p className="integrity-callout__text">
                        {t("integritet.p8")}{" "}
                        <a
                          href="https://integritetua.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="integrity-link"
                        >
                          <strong>Integritetua</strong>{" "}
                          <i
                            className="fas fa-external-link-alt"
                            aria-hidden="true"
                          />
                        </a>{" "}
                        {t("integritet.p9")}
                      </p>
                    </div>
                  </div>

                  <div className="integrity-callout__actions">
                    <a
                      className="integrity-btn integrity-btn--primary"
                      href="https://integritetua.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("integritet.ui.integritetuaCta")}
                      <i className="fas fa-arrow-right" aria-hidden="true" />
                    </a>

                    <a
                      className="integrity-btn integrity-btn--ghost"
                      href="#dokumenti"
                    >
                      {t("integritet.ui.backToDocs")}
                      <i className="fas fa-chevron-up" aria-hidden="true" />
                    </a>
                  </div>
                </section>

                {/* PLAN (p10 + list) */}
                <section id="plan" className="values-section integrity-values">
                  <p className="integrity-values__lead">
                    {t("integritet.p10")}
                  </p>
                  <ul>
                    <li>{t("integritet.l1")}</li>
                    <li>{t("integritet.l2")}</li>
                    <li>{t("integritet.l3")}</li>
                    <li>{t("integritet.l4")}</li>
                    <li>{t("integritet.l5")}</li>
                  </ul>
                </section>
              </div>
            </div>

            {/* SIDEBAR */}
            <div className="col-md-4 pt-10">
              <aside className="sidebar-widget integrity-sidebar">
                {/* Quick nav */}
                <section className="widget widget_categories">
                  <h2 className="widget-title">
                    {t("integritet.ui.quickTitle")}
                  </h2>
                  <ul
                    className="integrity-quicknav"
                    aria-label={t("integritet.ui.quickAria")}
                  >
                    <li>
                      <a className="integrity-quicknav__link" href="#dokumenti">
                        <i className="far fa-file-pdf" aria-hidden="true" />
                        {t("integritet.ui.quickDocs")}
                      </a>
                    </li>
                    <li>
                      <a className="integrity-quicknav__link" href="#pregled">
                        <i className="fas fa-align-left" aria-hidden="true" />
                        {t("integritet.ui.quickOverview")}
                      </a>
                    </li>
                    <li>
                      <a
                        className="integrity-quicknav__link"
                        href="#integritetua"
                      >
                        <i className="fas fa-link" aria-hidden="true" />
                        IntegritetUA
                      </a>
                    </li>
                    <li>
                      <a className="integrity-quicknav__link" href="#plan">
                        <i className="fas fa-list-check" aria-hidden="true" />
                        {t("integritet.ui.quickPlan")}
                      </a>
                    </li>
                  </ul>
                </section>

                {/* Follow */}
                <section
                  id="custom_html-5"
                  className="widget_text widget widget_custom_html"
                >
                  <h2 className="widget-title">{t("sidebar.follow")}</h2>
                  <div className="textwidget custom-html-widget">
                    <div className="widget-social">
                      <a
                        href="https://www.facebook.com/fpebar.me"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Facebook"
                      >
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a
                        href="https://www.instagram.com/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                      <a
                        href="https://www.youtube.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="YouTube"
                      >
                        <i className="fab fa-youtube" />
                      </a>
                      <a
                        href="https://www.tiktok.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on Tiktok"
                        title="Tiktok"
                      >
                        <i className="fab fa-tiktok" />
                      </a>
                      <a
                        href="https://www.linkedin.com/school/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on LinkedIn"
                        title="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </div>
                  </div>
                </section>

                {/* Useful links */}
                <section id="categories-1" className="widget widget_categories">
                  <h2 className="widget-title">{t("sidebar.useful")}</h2>
                  <ul>
                    <li className="cat-item cat-item-16">
                      <Link to="/o-fpep">{t("about.fpep")}</Link>
                    </li>
                    <li className="cat-item cat-item-23">
                      <Link to="/akreditacija-fpep">
                        {t("admission.Akreditacija")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-18">
                      <Link to="/upis">{t("upis.title")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/cijene-studija">
                        {t("admission.Skolarina")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/projekti">{t("saradnja.projekti")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/galerija">{t("navbar.Gallery")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/novosti">{t("navbar.News")}</Link>
                    </li>
                  </ul>
                </section>

                {/* Study programs */}
                <section
                  id="recent-posts-4"
                  className="widget widget_recent_entries"
                >
                  <h2 className="widget-title">{t("sidebar.study")}</h2>
                  <ul>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.osnovne")}</strong> <br />
                      </span>
                      <Link to="/racunovodstvo-finansije-i-bankarstvo">
                        {t("osnovne.rfb")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment">
                        {t("osnovne.menadzment")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-osnovne">
                        {t("osnovne.pravo")}
                        <br />
                      </Link>
                    </li>

                    <li>
                      <span className="post-date">
                        <strong>{t("programs.master")}</strong> <br />
                      </span>
                      <Link to="/poslovna-ekonomija">
                        {t("master.poslovnaEkonomija")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/ekonomija-javnog-sektora">
                        {t("master.ekonomijaJavnogSektora")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-master">
                        {t("master.pravo")}
                        <br />
                      </Link>
                    </li>

                    <li>
                      <span className="post-date">
                        <strong>{t("programs.specijalisticke")}</strong> <br />
                      </span>
                      <Link to="/menadzment-javnog-sektora-specijalisticke">
                        {t("specijalisticke.mjs")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment-profitnog-sektora-specijalisticke">
                        {t("specijalisticke.mps")}
                        <br />
                      </Link>
                    </li>
                  </ul>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default AkademskiIntegritet;
